import { AssociatedAccount } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RequestType, web3Api } from 'store/queries';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchAssociatedAccounts },
  useFetchAssociatedAccountsQuery,
  useLazyFetchAssociatedAccountsQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchAssociatedAccounts: build.query<AssociatedAccount[], void>({
      providesTags: [RequestType.BoundAccounts],
      queryFn: createNotifyingQueryFn(async () => {
        const api = MultiService.getService().getAccountingGateway();

        const data = await api.getAssociatedAccounts();

        return { data };
      }),
    }),
  }),
  overrideExisting: true,
});

const fetchAssociatedAccountsFallback: AssociatedAccount[] = [];

export const {
  selectDataWithFallbackCachedByParams: selectAssociatedAccounts,
  selectLoadingCachedByParams: selectAssociatedAccountsLoading,
  selectStateCachedByParams: selectAssociatedAccountsState,
} = createQuerySelectors({
  endpoint: fetchAssociatedAccounts,
  fallback: fetchAssociatedAccountsFallback,
});
